import { Component, input, InputSignal, inject, ViewEncapsulation, signal, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'lb-responsive-layout',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './responsive-layout.component.html',
	styleUrl: './responsive-layout.component.scss',
	encapsulation: ViewEncapsulation.None
})
export class ResponsiveLayoutComponent implements OnInit, OnDestroy {
	private _resizeObserver?: ResizeObserver;

	public stickyLeft: InputSignal<boolean> = input<boolean>(false);
	public autoCloseSlideout: InputSignal<boolean> = input<boolean>(true);
	public slideoutAriaLabel: InputSignal<string> = input<string>('Navigation menu');

	// Signal to track if we're in mobile view
	public isMobile = signal<boolean>(false);
	public mobileMenuOpen = signal<boolean>(false);

	ngOnInit() {
		this._checkViewport();
		this._setupResizeObserver();
	}

	ngOnDestroy() {
		this._resizeObserver?.disconnect();
	}

	public openSlideout(): void {
		if (this.isMobile()) {
			this.mobileMenuOpen.set(true);
		}
	}

	public closeSlideout(): void {
		this.mobileMenuOpen.set(false);
	}

	public toggleSlideout(): void {
		if (this.isMobile()) {
			this.mobileMenuOpen.update((open) => !open);
		}
	}

	public closeMobileMenu(): void {
		this.mobileMenuOpen.set(false);
	}

	private _checkViewport() {
		// 768px is the tablet breakpoint from your SCSS
		const wasMobile = this.isMobile();
		this.isMobile.set(window.innerWidth <= 768);

		// Close menu when switching to desktop
		if (wasMobile && !this.isMobile()) {
			this.mobileMenuOpen.set(false);
		}
	}

	private _setupResizeObserver() {
		this._resizeObserver = new ResizeObserver(() => {
			this._checkViewport();
		});
		this._resizeObserver.observe(document.body);
	}
}
